import axios from 'axios'
import { AxiosRequestConfig } from 'axios'
import { getToken, removeToken } from '@/utils/auth'
import { MessageBox } from 'mint-ui'
// 跳转用url
const url = BASE_API.PHP

// 创建axios实例
const service = axios.create({
  autoMsg: true,
} as AxiosRequestConfig)

// request拦截器
service.interceptors.request.use(config => {
  // Do something before request is sent
  const token = getToken()
  const newConfig = Object.assign({}, config)
  if (token) {
    const AUTHORIZATION = 'Authorization'
    newConfig.headers[AUTHORIZATION] = token // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
  }
  return newConfig
}, error => {
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    let errMsg = ''
    if (res.errcode === 10000) {
      removeToken()
      // window.location.href = `${url}/wechat/access`
    } else if (res.errcode === 10001) {
      errMsg = res.msg || res.data
    } else if (res.errcode !== 0) {
      errMsg = res.msg || '服务器错误'
    }
    // 错误提示
    const config: any = response.config
    if (errMsg && config.autoMsg) {
      // alert(errMsg)
      MessageBox('提示', errMsg)
    }
    return response
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
